import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getAuthHeaders } from "../../../utility/getAuthHeaders";
import { base_url } from "../../../api/api-url";

export const fetchTicketTrash = createAsyncThunk(
  "ticketTrash/fetchTicketTrash",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${base_url}/ticket-trash`, getAuthHeaders());
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const deleteTicketPermanently = createAsyncThunk(
  "ticketTrash/fetchTicketTrash",
  async (data, {dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(`${base_url}/ticket-delete-permanently/${data}`, getAuthHeaders());
      dispatch(fetchTicketTrash())
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const ticketTrashSlice = createSlice({
  name: "ticketTrash",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTicketTrash.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTicketTrash.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchTicketTrash.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default ticketTrashSlice.reducer;
